import { Chart } from '@antv/g2';
import React, { useEffect } from 'react';

const TransactionsForHoursChart = ({ transactionsHourData }) => {

  const transactionsMainChart = () => {
    const chart = new Chart({
      container: 'transactions-for-hours',
      autoFit: true,
      height: 500,
    });

    chart.options({
      type: 'interval',
      transform: [{ type: 'stackY' }],
      encode: {
        x: 'hour',
        y: 'count',
        color: 'type',
      },
      legend: {
        color: {
          position: 'right',
          layout: 'vertical',
          align: 'middle',
          itemWidth: 24,
          itemHeight: 24,
          label: {
            font: '16px sans-serif',
            fill: '#333',
          },
        },
      },
      scale: {
        color: {
          range: [
            '#4CAF50',  // Violeta base
            '#F4A261',  // Naranja base
            '#8F6FF7',  // Violeta claro
            '#D5A1F2',  // Violeta suave pastel
            '#9A6BFF',  // Violeta intermedio
            '#E3C2F2',  // Gris claro con tintes violetas
            '#7A4DD4',  // Violeta más intenso
            '#C8A4E4',  // Violeta suave y claro
            '#C7A4FF',  // Violeta suave
            '#D8B3F0',  // Violeta cálido suave
            '#6B4CF7',  // Violeta intermedio oscuro
            '#B7A7E6',  // Gris muy claro con matices violetas
            '#5F1DB1',  // Violeta oscuro
            '#B9A3F7',  // Gris con tono violeta suave
            '#5733B8',  // Violeta frío
            '#F4A262',  // Naranja suave cálido
            '#4527A0',  // Violeta profundo
            '#B2A0E3',  // Gris suave con matices morados
            '#3A1A8C',  // Violeta intenso
            '#FF7F40',  // Naranja suave y cálido
          ]
        },
      },
      axis: {
        x: {
          title: false,
        },
        y: {
          title: null,
          label: {
            fontSize: 12,
            fill: '#555',
          },
          grid: true,
        }
      },
      interaction: {
        brushXFilter: true
      },
      tooltip: {
        title: 'Rechazos',
        items: [
          { channel: 'color', name: 'Tipo' },
          { channel: 'y', name: 'Cantidad' },
        ],
      }
    });

    chart.data(transactionsHourData);

    chart.render();
  };

  useEffect(() => {
    transactionsMainChart();
  }, [transactionsHourData]);

  return (
      <div id="transactions-for-hours" />
  );
}

export default TransactionsForHoursChart;